import { Api } from '@/services/Api'

export default {
  fetchGraphData (plantId, date, deviceId, parameter) {
    return Api().get(`/api/v2/pcs/graph/${plantId}/${date}/${deviceId}/${parameter}`)
  },
  fetchLiveActivePower (plantId) {
    return Api().get(`/api/v2/pcs/live/${plantId}`)
  },
  fetchPcsList (plantId) {
    return Api().get(`/api/v2/pcs/config/${plantId}`)
  }
}
